import {
  Button,
  Card,
  Grid,
  Icon,
  List,
  Modal,
  NavBar,
  SearchBar,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import { ImageViewer } from "antd-mobile-v5";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { PhoneFill } from "antd-mobile-icons";
import instance from "../../../util/axios";
import { BaseURL } from "../../../constant";
const MailListFrom = styled.div`
  .body {
    // width:100%;
    // padding:10px;
  }
  .title {
    position: fixed;
    height: 100px;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 100%;
    background-color: #ffffff;
  }
  .ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .li {
    width: 100%;
    height: 50px;
    border: 1px solid #797979;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    margin-bottom: 10px;
  }
  .pdd {
    padding: 0 10px 0 10px;
    margin-top: 6.2rem;
  }
  .size {
    font-size: 22px;
  }
  .margin {
    position: fixed;
    height: 3rem;
    margin-top: 3rem;
    width: 100%;
    padding: 0px;
  }
  .left {
    display: flex;
    // flex-direction: column;
    flex-direction: row;
    margin-left: 10px;
  }
  .right {
    margin-right: 10px;
    color: #007acc;
  }
  .am-navbar {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: 3rem;
    background-color: #ffffff;
    position: fixed;
    z-index: 9999;
    top: 0;
    width: 100%;
    color: #000000;
  }
  .titleName {
    width: 100%;
    background-color: #ffffff;
    height: 5rem;
    position: fixed;
  }
`;
interface Array1 {
  uuid: string;
  code: string;
  attachmentIds: string;
}
export default function QueryList() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [keyword, setKeyword] = useState<string>();
  const [orderId, setOrderId] = useState<string>();
  const [tableName, setTableName] = useState<string>();
  const [queryList, setqueryList] = useState<Array1[]>([]);
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [images, setImages] = useState<any[]>();
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url);
    let tstr = url.substring(url.indexOf("?") + 1).split("&");
    console.log(tstr);
    const orderId = tstr[0];
    const tableName = tstr[1];
    setOrderId(tstr[0]);
    setTableName(tstr[1]);
    instance
      .get(
        `/erp/radOrder/mobile/getOrderDetailList?orderId=` +
          orderId +
          "&tableName=" +
          tableName
      )
      .then((resp) => {
        // console.log(resp);
        if (resp.data.Status === "1") {
          setqueryList(resp.data.Data.data);
        }
      });
  }, []);
  const searchBarChange = useCallback((keyword) => {
    let url = window.location.href; //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("?") + 1).split("&");
    const orderId1 = tstr[0];
    const tableName1 = tstr[1];
    instance
      .get(
        `/erp/radOrder/mobile/getOrderDetailList?orderId=` +
          orderId1 +
          "&tableName=" +
          tableName1 +
          "&formulaName=" +
          keyword
      )
      .then((resp) => {
        console.log(resp);
        if (resp.data.Status === "1") {
          setqueryList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    instance
      .get(
        `/erp/radOrder/mobile/getOrderDetailList?orderId=` +
          orderId +
          "&tableName=" +
          tableName
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setqueryList(resp.data.Data.data);
        }
      });
  }, []);

  return (
    <>
      <MailListFrom>
        <div className="body">
          <div className="titleName">
            <NavBar
              className="orderNavBar"
              leftContent="返回"
              icon={
                <Icon
                  type="left"
                  onClick={() => {
                    history.go(-1);
                  }}
                />
              }>
              图纸查询
            </NavBar>
            <SearchBar
              value={keyword}
              onChange={(value) => setKeyword(value)}
              placeholder="请输入图号"
              className="margin"
              onSubmit={() => {
                searchBarChange(keyword);
              }}
              onCancel={() => {
                setKeyword("");
                noSearch();
              }}
              // onChange={searchBarChange}
            />
          </div>

          <WhiteSpace />
          <div className="pdd">
            <ul className="ul">
              {queryList.map((item) => (
                <li
                  className="li"
                  onClick={() => {
                    // window.location.href =
                    //   "/erp/drawinglist/viewpicture?attachmentIds=" +
                    //   item.attachmentIds;
                  }}>
                  <div className="left">
                    <span>{item.code}</span>
                    {item.attachmentIds && (
                      <a
                        style={{ color: "#02a7f0", marginLeft: 5 }}
                        href={
                          BaseURL +
                          `/downloadFileByMobile?uuid=${item.attachmentIds}`
                        }>
                        下载
                      </a>
                    )}
                  </div>
                  {item.attachmentIds && (
                    <div
                      className="right"
                      onClick={() => {
                        if (item.attachmentIds) {
                          setImages(
                            item.attachmentIds
                              .split(",")
                              .map(
                                (atta) =>
                                  BaseURL +
                                  "/oa/common/attachment/showImage?id=" +
                                  atta
                              )
                          );
                          setVisible(true);
                        } else {
                          setImages([]);
                        }
                      }}>
                      查看图纸
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          {queryList.length === 0 && (
            <div style={{ textAlign: "center", marginTop: "8rem" }}>
              <span>暂无更多数据</span>
            </div>
          )}
          <ImageViewer.Multi
            images={images}
            visible={visible}
            onClose={() => {
              setVisible(false);
            }}
          />
        </div>
      </MailListFrom>
    </>
  );
}
